export enum ResponseBodyConversions {
    Json = 'json',
    Stream = 'stream',
    ArrayBuffer = 'arraybuffer',
}
